import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PrivateRoute } from './customRoutes/ProtectedRoutes';
import StaffRoute from './customRoutes/StaffRoute';

import { ThemeProvider } from '@material-ui/core';
import theme from './theme';

import AwardBannerPage from './components/award/BannerPage';
import BrandRoutes from './components/brands/Routes';
import InfluencerRoutes from './components/influencers/Routes';
import ComingSoon from './components/ux/ComingSoon';
import LoginWrapper from './pages/LoginPage/LoginWrapper';
import InfluencerLogin from './components/InfluencerLogin/Index';
import InstagramCallback from './components/InfluencerLogin/InstagramCallback';
import MobilePriceIndexWrapper from './pages/PriceIndex/MobilePriceIndexWrapper';
import MobilePriceIndexDemoWrapper from './pages/PriceIndexDemo/MobilePriceIndexDemoWrapper';

import Planner from 'components/Planner';
import PlannerV2 from 'components/PlannerV2/Index.jsx';

import CompetitorsInsights from './components/CompetitorsInsights/Index';
import YTDetailInsights from 'components/DetailedInsights/ytDetailedInsights';
import InstagramDetailInsights from 'components/DetailedInsights/DetailedInsights';
import Discovery from './components/Discovery';
import CompetitorReportAnalysis from 'components/CompetitorReportAnalysis';
import CompetitorReportAnalysisUI from 'components/CompetitorReportAnalysisUI';
import { CompetitorReport, CreateReport } from 'components/CompetitorReport';
import { Landing, Create, Detail } from 'components/CompetitorReportDashboard';
import BrandConnect from 'components/BrandConnect';
import AIChat from 'components/AIChat/Index';
import InfluencerInsight from 'components/PlannerV2/components/InfluencerInsight';
import { devConfig } from './config';
import LoginSignupV2 from 'components/LoginSignupV2/Index.jsx';
import withTurnstile from 'components/LoginSignupV2/Captcha.jsx';
import PrivacyPolicy from 'components/legal/PrivacyPolicy';
import Terms from 'components/legal/Terms';
import ConnectorGuide from 'components/legal/ConnectorGuide';
import PublicInvoiceForm from 'components/invoices/PublicInvoiceForm';
import ComplianceFooter from 'components/Common/ComplianceFooter';
import FeedbackBoard from 'components/feedback/FeedbackBoard';

const API_HOST = devConfig.API_HOST;

const wrapIfNeeded = (Component) => {
  return API_HOST === "https://api.influencer.in"
    ? withTurnstile(Component)
    // ? Component
    : Component;
};

const ProtectedLoginSignup = wrapIfNeeded(LoginSignupV2);
const ProtectedLoginWrapper = wrapIfNeeded(LoginWrapper);
const ProtectedInfluencerLogin = wrapIfNeeded(InfluencerLogin);
const ProtectedBrandRoutes = wrapIfNeeded(BrandRoutes);
const ProtectedInfluencerRoutes = wrapIfNeeded(InfluencerRoutes);
const ProtectedInfluencerInsight = wrapIfNeeded(InfluencerInsight);
const ProtectedComingSoon = wrapIfNeeded(ComingSoon);
const ProtectedAwardBannerPage = wrapIfNeeded(AwardBannerPage);
const ProtectedMobilePriceIndexWrapper = wrapIfNeeded(MobilePriceIndexWrapper);
const ProtectedMobilePriceIndexDemoWrapper = wrapIfNeeded(MobilePriceIndexDemoWrapper);
const ProtectedDiscovery = wrapIfNeeded(Discovery);
const ProtectedPlannerV2 = wrapIfNeeded(PlannerV2);
const ProtectedPlanner = wrapIfNeeded(Planner);
const ProtectedYTDetailInsights = wrapIfNeeded(YTDetailInsights);
const ProtectedInstagramDetailInsights = wrapIfNeeded(InstagramDetailInsights);
const ProtectedCompetitorsInsights = wrapIfNeeded(CompetitorsInsights);
const ProtectedCompetitorReportAnalysis = wrapIfNeeded(CompetitorReportAnalysis);
const ProtectedCompetitorReportAnalysisUI = wrapIfNeeded(CompetitorReportAnalysisUI);
const ProtectedCompetitorReport = wrapIfNeeded(CompetitorReport);
const ProtectedCreateReport = wrapIfNeeded(CreateReport);
const ProtectedCompetitorReportLanding = wrapIfNeeded(Landing);
const ProtectedCompetitorReportCreate = wrapIfNeeded(Create);
const ProtectedCompetitorReportDetail = wrapIfNeeded(Detail);
const ProtectedBrandConnect = wrapIfNeeded(BrandConnect);
const ProtectedAIChat = wrapIfNeeded(AIChat);

class AppRouter extends React.Component {
  render() {
    return (
      <React.Fragment>
      <Switch>
        <Route exact path={'/'}>
          <Redirect to="/login" />
        </Route>

        {/* Auth Routes */}
        <Route exact path={'/login'} component={ProtectedLoginSignup} />
        <Route exact path={'/signup'} component={ProtectedLoginSignup} />
        <Route exact path={'/forgot-password'} component={ProtectedLoginSignup} />
        <Route exact path={'/password-reset-confirm/:uid/:token'} component={ProtectedLoginSignup} />
        {/* <Route exact path={'/login'} component={LoginWrapper} /> */}
        {/* Dedicated creator sign-in; /login/creators keeps the legacy tabbed page */}
        <Route exact path={'/login/influencer'} component={ProtectedInfluencerLogin} />
        {/* Instagram's direct flow is a full-page redirect, so it lands
            here rather than back in a popup. Deliberately not wrapped in
            the Turnstile guard: the creator already passed it on the way
            out, and re-challenging them mid-redirect loses the code. */}
        <Route exact path={'/instagram/callback'} component={InstagramCallback} />
        <Route exact path={'/login/creators'} component={ProtectedLoginWrapper} />
        <Route exact path={'/login/brands'} component={ProtectedLoginWrapper} />
        <Route exact path={'/signup/creators'} component={ProtectedLoginWrapper} />
        <Route exact path={'/signup/brands'} component={ProtectedLoginWrapper} />

        {/* Legal / compliance pages */}
        <Route exact path={'/privacy-policy'} component={PrivacyPolicy} />
        <Route exact path={'/terms'} component={Terms} />
        <Route exact path={'/connector-guide'} component={ConnectorGuide} />
        {/* IN-1718 exception path: invoice without signing in, via a
            staff-issued link. Public by design — the token is the key. */}
        <Route exact path={'/invoice/submit/:token'} component={PublicInvoiceForm} />

        {/* Other Public Routes */}
        <Route exact path={'/planner/profile/:platform/:handle'} component={ProtectedInfluencerInsight} />
        <Route exact path={'/comingsoon'} component={ProtectedComingSoon} />
        <Route exact path={'/creator-awards'} component={ProtectedAwardBannerPage} />
        <Route exact path={'/past'} component={ProtectedComingSoon} />
        <Route exact path={'/price-index'} component={ProtectedMobilePriceIndexWrapper} />
        <Route exact path={'/price-index-demo'} component={ProtectedMobilePriceIndexDemoWrapper} />

        <Route
          exact
          path={'/discovery'}
          render={() => (
            <ThemeProvider theme={theme}>
              <ProtectedDiscovery />
            </ThemeProvider>
          )}
        />

        {/* Private Routes */}
        <PrivateRoute path={'/brand'} component={ProtectedBrandRoutes} />
        <PrivateRoute path={'/influencer'} component={ProtectedInfluencerRoutes} />
        <PrivateRoute exact path={'/planner'}>
          <Redirect to="/planner/discover" />
        </PrivateRoute>
        <PrivateRoute path={'/planner'} component={ProtectedPlannerV2} />
        <PrivateRoute path={'/brandconnect'} component={ProtectedBrandConnect} />
        {/* The invoice console moved into the planner shell so it keeps the
            header and sidebar; this keeps older links working. */}
        <Route exact path={'/internal/invoices'}>
          <Redirect to="/planner/invoices" />
        </Route>
        {/* Internal staff assistant. The API enforces the staff gate; the page
            renders a plain 'staff only' notice for anyone else. */}
        <PrivateRoute exact path={'/ai-chat'} component={ProtectedAIChat} />
        {/* The product team's triage board. Deliberately outside the planner
            shell: triage wants the full width, and the people doing it are
            not using the planner at the time. StaffRoute keeps everyone else
            off it, and the API enforces the same gate. */}
        <StaffRoute exact path={'/feedbackboard'} component={FeedbackBoard} />
        <PrivateRoute path={'/planner-v1'} component={ProtectedPlanner} />
        <PrivateRoute
          exact
          path={'/competitor-insights/:brand_id/:keyword/youtube/detailed-insights'}
          component={ProtectedYTDetailInsights}
        />
        <PrivateRoute
          exact
          path={'/competitor-insights/:brand_id/:keyword/instagram/detailed-insights'}
          component={ProtectedInstagramDetailInsights}
        />
        <PrivateRoute path={'/competitor-insights/:brand_id/:keyword?'} component={ProtectedCompetitorsInsights} />
        <PrivateRoute path={'/competitor-insights/'} component={ProtectedCompetitorsInsights} />
        <PrivateRoute
          path={'/competitor-report-analysis/:brand_id'}
          component={ProtectedCompetitorReportAnalysis}
        />
        <PrivateRoute
          path={'/competitor-report-analysis-ui/:brand_id'}
          component={ProtectedCompetitorReportAnalysisUI}
        />
        <PrivateRoute
          exact
          path={'/competitor-report'}
          component={ProtectedCompetitorReport}
        />
        <PrivateRoute
          exact
          path={'/competitor-report/create'}
          
          component={ProtectedCreateReport}
        />
        <PrivateRoute
          exact
          path={'/competitor-report-dashboard'}
          component={ProtectedCompetitorReportLanding}
        />
        <PrivateRoute
          exact
          path={'/competitor-report-dashboard/create'}
          component={ProtectedCompetitorReportCreate}
        />
        <PrivateRoute
          exact
          path={'/competitor-report-dashboard/edit/:id'}
          component={ProtectedCompetitorReportCreate}
        />
        <PrivateRoute
          exact
          path={'/competitor-report-dashboard/detail/:id'}
          component={ProtectedCompetitorReportDetail}
        />
      </Switch>
      <ComplianceFooter />
      </React.Fragment>
    );
  }
  componentDidMount() {
    document.title = 'Influencer.in';
  }
}

export default AppRouter;
